"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.search = void 0;
const helper_1 = require("../helper");
const mapAlgoliaSearchResult_1 = require("../helper/mapAlgoliaSearchResult");
const search = async ({ client, queries, }) => {
    const searchResponse = await client.search(queries.map(query => ({
        indexName: query.indexName,
        params: (0, helper_1.getSearchOptions)(query.objectType, query.search, query.options),
    })));
    return searchResponse.results.map((result, index) => ({
        queryId: result.queryID,
        results: result.hits.map(hit => (0, mapAlgoliaSearchResult_1.mapAlgoliaSearchResult)(queries[index].objectType, hit)),
    }));
};
exports.search = search;
//# sourceMappingURL=search.js.map